import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Apps,
  AppsWidget,
  Audiencias,
  Instagram,
  MenuDia,
  Note,
  Resume,
  HablandoPlata,
  PeriodismoConfiable,
  TwitterWhite,
  Logo1,
  Gympass,
  Premio,
  OracleHCM,
  EmailLogo,
  EventPlayer,
  Hoop
} from '../../../../assets/images/index';
import { WIDGET_DOWN, WIDGET_UP } from '../../../constants/actionTypes';
import Widget from '../../containers/Widget';
import request from '../../../utils/api';
import { API_SOCIAL } from '../../../constants/api';
import {
  StyledHeader,
  StyledList,
  StyledTitle,
  StyledWidgetBox
} from './style';

const options = [
  { name: 'Subir', action: WIDGET_UP },
  { name: 'Bajar', action: WIDGET_DOWN }
];

const colors = {
  shortcut: 'colorTwo',
  menuofday: 'colorThree',
  audiences: 'colorTwo',
  audiencesradio: 'colorFour',
  digitalaudiences: 'colorSix',
  pressNote: 'colorOne',
  courses: 'colorOne',
  customWidget: 'colorSix',
  zerowaste: 'blueLinkedin',
  plata: 'colorPlata'
};

const icons = {
  shortcut: AppsWidget,
  shortcutWidget: Apps,
  menuofday: MenuDia,
  audiences: Audiencias,
  audiencesradio: Audiencias,
  digitalaudiences: Audiencias,
  rrssaudiencia: Audiencias,
  ranking: Audiencias,
  resumen: Resume,
  pressrelease: Note,
  md3: Resume,
  plata: HablandoPlata,
  periodismo: PeriodismoConfiable,
  strategy: Resume,
  twitter: TwitterWhite,
  instagram: Instagram,
  zerowaste: Premio,
  atresmedia_ia: Premio,
  customWidget: EmailLogo,
  wearemodule: Logo1,
  gympass: Gympass,
  oraclehcm: OracleHCM,
  player: EventPlayer,
  player2: EventPlayer,
  editAtresmedia: EventPlayer,
  hoop: Hoop
};

const LinkRender = ({ children, link, type, url }) => {
  let renderComponent;
  if (
    type &&
    (type === 'md3' ||
      type === 'plata' ||
      type === 'periodismo' ||
      type === 'strategy' ||
      type === 'zerowaste' ||
      type === 'customWidget' ||
      type === 'wearemodule' ||
      type === 'gympass' ||
      type === 'oraclehcm')
  ) {
    const dynamicId = `link-${type}`;
    renderComponent = (
      <a href={url} target="_blank" id={dynamicId} rel="noopener noreferrer">
        {children}
      </a>
    );
  } else if (link) {
    renderComponent = <Link to={link}>{children}</Link>;
  } else {
    renderComponent = <div>{children}</div>;
  }
  return renderComponent;
};

const WidgetBox = ({
  index,
  name,
  title,
  type,
  link,
  url,
  onClickOption,
  id,
  className
}) => {
  const [logoCW, setLogoCW] = useState(null);
  const [loadingWidget, setLoadingWidget] = useState(true);
  useEffect(() => {
    request(`${API_SOCIAL}widget/home`, {
      params: '',
      method: 'GET'
    }).then(response => {
      response.map(el => {
        if (el.type === 'customWidget') {
          setLogoCW(el.logo);
        }
        return el.logo;
      });
      setLoadingWidget(false);
    });
  }, []);

  if (loadingWidget) {
    return <div>Cargando...</div>;
  }
  if (type === 'player3' || type === 'player5') {
    return null;
  }
  return (
    <StyledWidgetBox
      className={type === 'menuofday' ? `${className} menuofday` : className}
      type={type}
    >
      {type !== 'oraclehcm' && type !== 'atresmedia_ia' && (
        <StyledHeader>
          {link || url ? (
            <LinkRender url={url} link={link} type={type}>
              {type === 'customWidget' && logoCW ? (
                <StyledTitle
                  title={title || name}
                  type={type}
                  icon={logoCW}
                  downloadIcon={type === 'plata'}
                />
              ) : (
                <StyledTitle
                  preTitle={type === 'periodismo' ? 'ATRESMEDIA' : ''}
                  title={title || name}
                  type={type}
                  icon={icons[type]}
                  downloadIcon={type === 'plata' || type === 'periodismo'}
                />
              )}
            </LinkRender>
          ) : (
            <StyledTitle
              title={title || name}
              type={type}
              icon={icons[type]}
              className="WidgetBox-title"
            />
          )}
          {type !== 'oraclehcm' && type !== 'atresmedia_ia' && (
            <StyledList
              type={colors[type]}
              onClickOption={action => onClickOption(index, action)}
              options={options}
              id={id}
            />
          )}
        </StyledHeader>
      )}
      {type && <Widget type={type} />}
    </StyledWidgetBox>
  );
};

export default WidgetBox;
